export function normalizeId(id) {
  if (id == null) {
    return null
  }

  return String(id)
}

export function isMsgRead(msg) {
  if (!msg) {
    return true
  }

  const { read } = msg

  if (read === true || read === 1 || read === '1' || read === 't' || read === 'true') {
    return true
  }

  return false
}

export function isConvoUnread(convo, currentUser) {
  if (!convo || !currentUser) {
    return false
  }

  // Server flag: any unread message from the other user in this convo
  if (typeof convo.has_unread === 'boolean') {
    return convo.has_unread
  }

  if (!convo.last_msg) {
    return false
  }

  const fromOtherUser = normalizeId(convo.last_msg.user_id) !== normalizeId(currentUser.id)

  return fromOtherUser && !isMsgRead(convo.last_msg)
}

export function countUnreadConvos(convos, currentUser) {
  if (!convos || !currentUser) {
    return 0
  }

  return convos.filter((convo) => isConvoUnread(convo, currentUser)).length
}
